<template>
    <v-img v-if="loadSuccess" :src="img" />
    <v-progress-circular indeterminate v-else size="20" ></v-progress-circular>
</template>
<script>
import PackShipService from "@/services/PackShipService";

export default {
    props: {
        image_guid: null,
        lazy_url: null
    },
    data: () => ({
        img: ""
    }),
    created: function() {
        this.fetImage(this.image_guid);
    },
    methods: {
        async fetImage(guid) {
            await PackShipService.dropTicketImage(guid)
            .then(data => {
                this.img = "data:image/png;base64," + data.data
            })
            .catch(err => {
                // eslint-disable-next-line
                console.log(err);
            });
        }
    },
    computed: {
    loadSuccess() {
      if (this.data != "")
        return true;
      else 
      return false;
    }
  }

};
</script>